
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[storeId]",
      function () {
        return require("private-next-pages/store/[storeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[storeId]"])
      });
    }
  